import { Link, useNavigate, useRouterState } from "@tanstack/react-router";
import { memo, useEffect, useRef, useState } from "react";
import { TbHome } from "react-icons/tb";
import { logout } from "../../lib/PB/Users";
import { defaultUserValues, useUserStore } from "../../store/UserStore";
import { Button } from "./Button";

function Sidebar() {
  const { logedIn, setLoggedInUser, setIsLoggedIn } =
    useUserStore();
  const navigate = useNavigate();
  const routerState = useRouterState();
  useEffect(() => {
    setOpen(false);
  }, [routerState.location.pathname]);
  const [Open, setOpen] = useState(false);
  const sidebarRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setOpen(false); // Close the sidebar
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const logoutHandler = () => {
    logout();
    setLoggedInUser(defaultUserValues);
    setIsLoggedIn(false);
    navigate({ to: "/Home" });
  };

  return (
    <>
      <button
        data-drawer-target="sidebar-multi-level-sidebar"
        data-drawer-toggle="sidebar-multi-level-sidebar"
        aria-controls="sidebar-multi-level-sidebar"
        type="button"
        className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        onClick={() => setOpen(true)}
      >
        <svg
          className="w-6 h-6"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          ></path>
        </svg>
      </button>
      {Open && (
        <div className="flex items-center justify-center flex-nowrap w-[100%]">
          <aside
            ref={sidebarRef}
            id="sidebar-multi-level-sidebar"
            className="fixed top-0 left-0 z-40 w-[50%] h-screen sm:translate-x-0"
            aria-label="Sidebar"
          >
            <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800">
              <ul className="space-y-2 font-medium text-lg">
                <li>
                  <Link
                    to="/Home"
                    className="[&.active]:font-bold flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <TbHome />
                    <span className="flex-1 ms-3 whitespace-nowrap">Home</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/Trips/Create"
                    className="[&.active]:font-bold flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <TbHome />
                    <span className="flex-1 ms-3 whitespace-nowrap">
                      Create Trip
                    </span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/Users/Invite"
                    className="[&.active]:font-bold flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <TbHome />
                    <span className="flex-1 ms-3 whitespace-nowrap">
                      Invite user
                    </span>
                  </Link>
                </li>
                {!logedIn ? (
                  <li>
                    <Link
                      to="/Auth/Login"
                      className="[&.active]:font-bold flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                    >
                      <span className="flex-1 ms-3 whitespace-nowrap">
                        Login
                      </span>
                    </Link>
                  </li>
                ) : (
                  <li>
                    <Button
                      className="[&.active]:font-bold flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                      type="button"
                      variant="link"
                      onClick={logoutHandler}
                    >
                      <span className="flex-1 ms-3 whitespace-nowrap">
                        Logout
                      </span>
                    </Button>
                  </li>
                )}
              </ul>
            </div>
          </aside>
          <div
            className={`fixed inset-0 bg-black bg-opacity-50 z-30 ${Open ? "block" : "hidden"}`}
          ></div>
        </div>
      )}
    </>
  );
}

export default memo(Sidebar);
